<template>
  <carousel
    :pagination-enabled="false"
    class="container-carrousel"
    :per-page-custom="[[468, 3], [768, 4], [1100, 5], [1500, 6], [1980, 7],[2560, 9]]"
  >
    <slide
      v-for="item of situacoes"
      v-show="situacoes.length > 0"
      :key="item.id"
      class="slide-item"
    >
      <div
        class="container-slider"
        :class="item.active ? 'active' : ''"
        @click="activeItem(item.id), $emit('change', item.active ? item.id : null)"
      >
        <div class="container-title">
          {{ item.count }}
        </div>
        <div class="container-label">
          <font-awesome-icon :size="item.icon.size" :color="item.icon.color" :icon="item.icon.type" />
          <span class="item-title"> {{ item.label }}</span>
        </div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
	components: {
		Carousel,
		Slide
	},
	props: {
		data: {
			type: Array,
			default: () => [],
		},
		marginBotton: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			situacoes: this.data || [],
		};
	},
	computed: {
		styles() {
			return {
				marginBotton: this.marginBotton,
			};
		},
	},
	methods: {
		activeItem(clickedItem) {
			const newItems = [];
			this.situacoes = this.situacoes.map((item) => {
				if (item.id === clickedItem) {
					// eslint-disable-next-line no-param-reassign
					item.active = !item.active;
				} else {
					// eslint-disable-next-line no-param-reassign
					item.active = false;
				}

				newItems.push(item);
				return false;
			});
			this.situacoes = newItems;
		}
	},
};
</script>

<style scoped>

.container-carrousel {
  margin-top: 20px;
  margin-bottom: 30px;
}
.container-label {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 5px;
}
.container-slider {
  background-color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-right: 10px;
  height: 100px;
  color: #000;
  align-self: flex-end;
  justify-self: flex-end;
  border-radius: 5px;
  padding: 20px;
  transition: 300ms ease-in-out;
  border-bottom: 3px solid #FFF;
  box-shadow: -1px 12px 18px 0 #dadee8;
  margin-bottom: 20px;
}
.container-slider:hover {
  border-bottom: 3px solid #2478ffcb;
  cursor: pointer;
}
.container-slider.active {
  border-bottom: 3px solid #2477ff;
  cursor: pointer;
}
.item-title {
  font-size: 12px;
  margin-left: 10px;
}
.container-title {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
}

</style>
